import { isMainThread } from "worker_threads";
import "./FormProgressBar.css";
import { lightenColor } from "../shared/uiHelpers";

const FALLBACK_COLOR = "lightblue";

type FormProgressBarProps = {
    progressPercentage: number;
    isMobileLayout: boolean;
    buttonColor?: string;
};

export const FormProgressBar = ({ progressPercentage, isMobileLayout, buttonColor = FALLBACK_COLOR }: FormProgressBarProps) => {

    const progressColor = lightenColor(buttonColor, 60);

    console.log("[FormProgressBar] progressPercentage: ", progressPercentage);

    return (
        <div 
            className="form-progress-bar"
            style={{
                ...{backgroundColor: progressColor},
                ...(isMobileLayout ? { position: "absolute" } : { position: "fixed" })
            }}
        >
            <div 
                className="form-progress-bar-progress" 
                style={{ 
                    width: `${progressPercentage}%`, 
                    backgroundColor: buttonColor,
                    // opacity: 0.5,
                }} />
        </div>
    );
};